import { render, staticRenderFns } from "./basic-modal.vue?vue&type=template&id=36750086&scoped=true&"
import script from "./basic-modal.vue?vue&type=script&lang=js&"
export * from "./basic-modal.vue?vue&type=script&lang=js&"
import style0 from "./basic-modal.vue?vue&type=style&index=0&id=36750086&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36750086",
  null
  
)

export default component.exports